import React, { useCallback } from 'react';
import { alpha } from '@mui/material';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import useEmotionStyles from '../../hooks/useEmotionStyles';
import RenderStringOrComponent from '../../misc/RenderStringOrComponent';
import { Spacer } from '../../misc/Spacer';
var getBorder = function (theme, _a) {
    var error = _a.error, isSelected = _a.isSelected, disabled = _a.disabled;
    if (error) {
        return "1px solid ".concat(theme.palette.error.main);
    }
    if (isSelected && !disabled) {
        return "1px solid ".concat(theme.palette.primary.main);
    }
    return "1px solid ".concat(theme.palette.grey[300]);
};
var getBackgroundColor = function (theme, _a) {
    var disabled = _a.disabled, isSelected = _a.isSelected;
    if (disabled && isSelected) {
        return alpha(theme.palette.grey['800'], 0.1);
    }
    if (isSelected) {
        return alpha(theme.palette.primary.main, 0.1);
    }
    return 'transparent';
};
var styles = function (theme, _a) {
    var error = _a.error, isSelected = _a.isSelected, disabled = _a.disabled;
    return ({
        root: {
            borderRadius: '2px',
            border: getBorder(theme, { disabled: disabled, error: error, isSelected: isSelected }),
            background: getBackgroundColor(theme, { disabled: disabled, error: error, isSelected: isSelected }),
            boxShadow: isSelected && !disabled
                ? "0 0 2px ".concat(theme.palette.primary.main)
                : 'none',
            '&:hover': {
                border: "1px solid ".concat(error ? theme.palette.error.main : theme.palette.primary.main),
            },
            minHeight: '48px',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginBottom: '0',
        },
        rootRadio: {
            color: theme.palette.grey[600],
        },
        formLabelRadio: {
            width: '100%',
            margin: 0,
        },
        radioLabel: {
            whiteSpace: 'break-spaces',
        },
    });
};
function RadioOption(_a) {
    var label = _a.label, value = _a.value, description = _a.description, error = _a.error, isSelected = _a.isSelected, disabled = _a.disabled, onSelect = _a.onSelect;
    var classes = useEmotionStyles(styles, { error: error, isSelected: isSelected, disabled: disabled });
    var handleSelect = useCallback(function (event, isChecked) {
        isChecked && !!onSelect && onSelect(event, value);
    }, [onSelect, value]);
    return (React.createElement(Box, null,
        React.createElement(Box, { className: classes.root },
            React.createElement(FormControlLabel, { classes: { root: classes.formLabelRadio }, value: String(value), control: React.createElement(Radio, { color: 'primary', classes: { root: classes.rootRadio }, disabled: disabled }), label: React.createElement("span", { className: classes.radioLabel }, label), onChange: handleSelect })),
        typeof description === 'string' && (React.createElement(React.Fragment, null,
            React.createElement(Spacer, { size: 0.5 }),
            React.createElement(RenderStringOrComponent, { toRender: description, variant: 'hint' }),
            React.createElement(Spacer, { size: 1 })))));
}
export default RadioOption;
